// extracted by mini-css-extract-plugin
module.exports = {"brand_primary":"var(--brand-primary)","grey_import_text":"grey_modal__grey_import_text__tSPjU"};